import { memo } from 'react';
import { ISkill } from '../../../mechanics/characters/Character'
import { uiSlice } from '../../../store/reducers/uiReducer';
import { useAppDispatch } from '../../../store/store';
import ImgWithFallback from '../../ui/ImgWithFallback';

interface ISkillsItemProps {
    skill: ISkill
    setIsToolTipView: React.Dispatch<React.SetStateAction<boolean>>
    handleSkillClick: () => void
    cooldown: number
    schosenStyle: string
}

const UserCharactersSkillsItem = ({ skill, setIsToolTipView, handleSkillClick, cooldown, schosenStyle }: ISkillsItemProps) => {
    const dispatch = useAppDispatch()
    const { setToolTipContent } = uiSlice.actions

    function callToolTip(tipContent: string) {
        setIsToolTipView(true)
        dispatch(setToolTipContent(tipContent))
    }

    return (
        <li
            className={`skills__item ${schosenStyle}`}
            onMouseEnter={() => callToolTip(skill.dis)}
            onMouseLeave={() => setIsToolTipView(false)}
            onClick={handleSkillClick}>
            <ImgWithFallback
                src={skill.images.webp}
                fallbackSrc={skill.images.img}
                styles={cooldown !== 0 ? { filter: "grayscale(1)" } : {}} />
            <span className='skills__item-cooldown'>{cooldown !== 0 ? cooldown : null}</span>
        </li>
    );
};

export default memo(UserCharactersSkillsItem);